import React from 'react'

import { ActivityForm } from './components'

const ActivityShow = () => <ActivityForm isShow />

export default ActivityShow
